/**
 * 信控
 */
export class CreditInfoUtil {
  /**
   * 获取信控请求参数
   * @param actionType
   * @returns {*}
   */
  static getJobData(job) {
    if (job) {
      return {
        lob: job.lob,
        opOffice: job.opOffice,
        customJobType: job.customJobType
      }
    }
    return null
  }
}
